<div class="row">
    <div class="col">
        <h6 class="pt-5px"><strong>App user list</strong></h6>
    </div>
    <div class="col">
        <button (click)="addUser()" class="btn btn-primary float-end">Add user</button>
    </div>
</div>
<div class="search">
    <div class="row">
        <div class="col-md col-sm-5">
            <input type="text" [(ngModel)]="queryParams.filterParams.name" class="form-control form-control-sm"
                placeholder=" Name " />
        </div>
        <div class="col-md col-sm-5">
            <input type="text" [(ngModel)]="queryParams.filterParams.email" class="form-control form-control-sm"
                placeholder=" Email " />
        </div>
        <div class="col-md-1">
            <button class="btn btn-primary" (click)="onClear()">Clear</button>
        </div>
        <div class="col-md-1">
            <button class="btn btn-primary" (click)="onSearch()">Search</button>
        </div>
    </div>
</div>
<div class="table-resp candid-table">
    <table class="table table-bordered">
        <tr>
            <th><a eosDebounce (debounceClick)="sort(!queryParams.reverse,'name')"> Full name
                    <img *ngIf="queryParams.reverse && queryParams.sortBy==='name'" src="design/images/filter.png"
                        class="float-end mt-3" />
                    <img *ngIf="!queryParams.reverse && queryParams.sortBy==='name'" src="design/images/filter-up.png"
                        class="float-end mt-3" style="transform:rotateX(180)" />
                </a>
            </th>
            <th> <a eosDebounce (debounceClick)="sort(!queryParams.reverse,'email')"> Email
                    <img *ngIf="queryParams.reverse && queryParams.sortBy==='email'" src="design/images/filter.png"
                        class="float-end mt-3" />
                    <img *ngIf="!queryParams.reverse && queryParams.sortBy==='email'" src="design/images/filter-up.png"
                        class="float-end mt-3" style="transform:rotateX(180)" />
                </a>
            </th>
            <th>Roles
                <!-- <a><img src="design/images/filter.png" class="float-end mt-3" /></a> -->
            </th>
            <!-- <th>Rank <a href="#"><img src="design/images/filter.png" class="float-end mt-3"/></a></th>
        <th>Sub - Service Line <a href="#"><img src="design/images/filter.png" class="float-end mt-3"/></a></th>
        <th>Service Line <a href="#"><img src="design/images/filter.png" class="float-end mt-3"/></a></th>
        <th>Office Location <a href="#"><img src="design/images/filter.png" class="float-end mt-3"/></a></th>
        <th>Status <a href="#"><img src="design/images/filter.png" class="float-end mt-3"/></a></th> -->
        <th width="80px" class="text-start">IsActive</th>    
        <th width="80px" class="text-center">Action</th>
        </tr>
        <tr *ngFor="let user of data.results">
            <td>{{user.displayName}} </td>
            <td>{{user.email}} </td>
            <td>{{ user.roles.join(', ') }}</td>
            <!-- <td><span class="status inprogress">In Process</span></td> -->
            <td>
                <span style="margin-left: 15px;" *ngIf="user.isActive"> ✔</span>  
                <span style="margin-left: 15px;" *ngIf="!user.isActive"> ✖ </span> 
            </td>
            <td class="text-center"><a (click)="editUser(user)"><img src="design/images/edit.png" /></a></td>
        </tr>
    </table>
</div>
<div class="row">
    <div class="col-md"></div>
    <div class="col-md">
        <div class="page-nav">
            <nav>
                <ul class="pagination ">
                    <li class="page-item" [ngClass]="{'disabled': currentPage - 1 < 1}">
                        <a class="page-link" (click)="pageChange(1)">
                            <span aria-hidden="true">&laquo;&laquo;</span>
                        </a>
                    </li>
                    <li class="page-item" [ngClass]="{'disabled': currentPage - 1 < 1}">
                        <a class="page-link" (click)="pageChange(currentPage - 1)" aria-label="Previous">
                            <span aria-hidden="true">&laquo;</span>
                        </a>
                    </li>
                    <li [ngClass]="{'active': pageNumber + i === currentPage }" class="page-item"
                        *ngFor="let i of pages">
                        <a (click)="pageChange(pageNumber + i)" class="page-link">{{pageNumber + i}}</a>
                    </li>
                    <li class="page-item" [ngClass]="{'disabled': currentPage + 1 > totalPages}">
                        <a class="page-link" (click)="pageChange(currentPage + 1)" aria-label="Next">
                            <span aria-hidden="true">&raquo;</span>
                        </a>
                    </li>
                    <li class="page-item" [ngClass]="{'disabled': currentPage + 1 > totalPages}">
                        <a class="page-link" (click)="pageChange(totalPages)">
                            <span aria-hidden="true">&raquo;&raquo;</span>
                        </a>
                    </li>
                </ul>
            </nav>
            <select (change)="onSelectChanges()" [(ngModel)]="data.itemsPerPage" class="form-select form-select-sm">
                <option *ngFor="let count of changeCount" [value]="count">{{count}}</option>
            </select>
            <p>Per page</p>
        </div>

    </div>
</div>